/* global axios */
import ApiClient from './ApiClient';

class AiReplySettingsAPI extends ApiClient {
  constructor() {
    super('ai_reply_settings', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.put(this.url, { ai_reply_settings: data });
  }

  testConnection(mode) {
    return axios.post(`${this.url}/test_connection`, null, {
      params: { mode },
    });
  }
}

export default new AiReplySettingsAPI();
